// Định dạng số tiền theo loại tiền (BR-06 / ISO 4217 minor units) — dùng chung
// cho toàn bộ luồng chuyển tiền quốc tế để tránh lệch định dạng giữa các bước.

// Số chữ số thập phân theo loại tiền (bảng SBV quy định):
// - Nhóm 0 thập phân: VND, JPY, KRW…
// - Nhóm 3 thập phân: BHD, KWD, OMR…
// - Còn lại (USD, EUR, GBP…): 2 thập phân.
const ZERO_DECIMAL_CCY = [
  "VND", "JPY", "KRW", "XOF", "XAF", "XPF", "CLP", "PYG",
  "BIF", "DJF", "GNF", "KMF", "RWF", "UGX", "VUV",
];
const THREE_DECIMAL_CCY = ["BHD", "IQD", "JOD", "KWD", "LYD", "OMR", "TND"];

export const getCurrencyScale = (code?: string): number => {
  const c = (code || "").toUpperCase();
  if (ZERO_DECIMAL_CCY.includes(c)) return 0;
  if (THREE_DECIMAL_CCY.includes(c)) return 3;
  return 2;
};

// Định dạng số tiền: phân tách nghìn bằng dấu phẩy, thập phân theo loại tiền.
export const formatMoney = (value: number, scale: number): string =>
  (value || 0).toLocaleString("en-US", {
    minimumFractionDigits: scale,
    maximumFractionDigits: scale,
  });

// Định dạng lại chuỗi tiền do BE trả về ("1,232 USD") theo đúng số chữ số
// thập phân của loại tiền (VD: "1,232 USD" -> "1,232.00 USD"). Giữ nguyên mã
// tiền tệ mà BE đã chọn; nếu không parse được thì trả lại chuỗi gốc.
export const reformatMoneyDisplay = (display?: string): string => {
  if (!display) return "—";
  const raw = display.trim();
  const ccyMatch = raw.match(/[A-Za-z]{3}/);
  const numMatch = raw.match(/[\d,]+(\.\d+)?/);
  if (!ccyMatch || !numMatch) return raw;
  const ccy = ccyMatch[0].toUpperCase();
  const value = Number(numMatch[0].replace(/,/g, ""));
  if (!Number.isFinite(value)) return raw;
  return `${formatMoney(value, getCurrencyScale(ccy))} ${ccy}`;
};
